<article class="conditionGuide" [ngClass]="{'no-border first-block': id === 0}">
  <div class="conditionGuide__title">{{ conditionName }}</div>
  <p class="conditionGuide__description">{{ goodCondition }}</p>

  <div *ngIf="displayRefusalReason" class="conditionGuide__refusalReason" [class.open]="showRefusalReason">
    <button class="conditionGuide__refusalReason__btn" (click)="toggleRefusalReason()">
      <span *ngIf="showRefusalReason; else hideRefusalReason" i18n="@@CONDITION_GUIDE.HIDE_REFUSAL_REASON_BTN"
        >Hide rejected criteria</span
      >
      <ng-template #hideRefusalReason>
        <span i18n="@@CONDITION_GUIDE.SHOW_REFUSAL_REASON_BTN">See rejected criteria</span>
      </ng-template>
    </button>
    <div class="conditionGuide__refusalReason__text" [class.open]="showRefusalReason">
      <p>{{ badCondition }}</p>
    </div>
  </div>
</article>
